import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';
import frTranslations from './locales/fr.json';
import deTranslations from './locales/de.json';
import jaTranslations from './locales/ja.json';
import zhTranslations from './locales/zh.json';
import thTranslations from './locales/th.json';

// Language detection from browser or localStorage
const getInitialLanguage = (): string => {
  // Check localStorage first
  const savedLanguage = localStorage.getItem('chat-app-language');
  if (savedLanguage) {
    return savedLanguage;
  }
  
  // Fall back to browser language
  const browserLanguage = navigator.language.split('-')[0];
  const supportedLanguages = ['en', 'es', 'fr', 'de', 'ja', 'zh', 'th'];
  
  return supportedLanguages.includes(browserLanguage) ? browserLanguage : 'en';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      es: { translation: esTranslations },
      fr: { translation: frTranslations },
      de: { translation: deTranslations },
      ja: { translation: jaTranslations },
      zh: { translation: zhTranslations },
      th: { translation: thTranslations },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    // Save language preference
    saveMissing: false,
    
    // Namespace configuration
    defaultNS: 'translation',
    ns: ['translation'],
    
    // Key separator
    keySeparator: '.',
    nsSeparator: ':',
    
    // Pluralization
    pluralSeparator: '_',
    contextSeparator: '_',
    
    // React specific options
    react: {
      useSuspense: false,
    },
  })
  .then(() => {
    console.log('i18n initialized successfully');
  })
  .catch((error) => {
    console.error('i18n initialization failed:', error);
  });

// Save language changes to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('chat-app-language', lng);
  document.documentElement.lang = lng;
});

// Set initial document language
document.documentElement.lang = i18n.language;

export default i18n;